// extracted by mini-css-extract-plugin
module.exports = {"card":"SignUp_card__1fyJp","description":"SignUp_description__3orFF"};